/**
 * Deep-link lander configuration.
 * Store destinations come from appLinks (build-time REACT_APP_* URLs).
 * An app id or package name is not turned into a public store URL.
 */

import { appLinks } from '../config/appLinks';

export const DEEP_LINK_HOST = 'https://app.lookbel.com';

export const STORE_URLS = {
  get ios(): string | null {
    return appLinks.ios;
  },
  get android(): string | null {
    return appLinks.android;
  },
};

/** www marketing site — login / browse after store or for desktop */
export const WEB_APP_ORIGIN =
  process.env.REACT_APP_WEB_ORIGIN || 'https://www.lookbel.com';

export function isDeepLinkHostname(hostname: string = window.location.hostname): boolean {
  return (
    hostname === 'app.lookbel.com' ||
    hostname === 'app.localhost' ||
    process.env.REACT_APP_FORCE_DEEPLINK_HOST === 'true'
  );
}

export function detectMobilePlatform(): 'ios' | 'android' | 'other' {
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'other';
}
